<template>
  <div v-if="templateRevision">
    <h1>
      <span>Revision&#160;</span>
      {{templateRevision.id}}
    </h1>
    <p>
      <v-btn :to="{name:'templates'}">
        <v-icon>chevron_left</v-icon>&#160;Templates
      </v-btn>
      <v-btn v-if="template" :to="{name:'template', params:{id:template.id}}">
        <v-icon>edit</v-icon>
        {{template.code}}
      </v-btn>
      <v-btn :to="{name:'snippet', params:{id:templateRevision.snippetid}}">
        <v-icon>edit</v-icon>&#160;Snippet
      </v-btn>
      <v-btn :to="{name:'revisionCopy', params:{id:templateRevision.id}}">
        <v-icon>file_copy</v-icon>&#160;Copy
      </v-btn>
      <v-btn @click="deleteRevision" v-if="documentCount != null && documentCount == 0">
        <v-icon>delete</v-icon>&#160;Delete
      </v-btn>
      <v-btn @click="exportRevision">
        <v-icon>cloud_download</v-icon>&#160;Export
      </v-btn>
      <v-btn @click="downloadRevision">
        <v-icon>picture_as_pdf</v-icon>&#160;Download
      </v-btn>
    </p>
    <v-alert
      :value="true"
      type="info"
    >A field is for admins to fill, and entry is for clients to fill.</v-alert>
    <span class="revisionEditable" v-if="templateRevision.locked">Editable</span>
    <span class="revisionPublished" v-if="!templateRevision.locked">Published</span>
    <a @click="togglePublish" v-if="templateRevision.locked">Publish</a>
    <Editor :templateRevisionId="$route.params.id" />
  </div>
</template>

<script>
import Editor from "@/components/document/revision/Editor";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Revision",
  metaInfo() {
    return {
      title: "Revision",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Editor },
  data() {
    return {
      templateRevision: null,
      snippet: null,
      template: null,
      documentCount: null
    };
  },
  methods: {
    async fetchTemplateRevision() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.templateRevision = response.data;
    },
    async fetchSnippet() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}/snippet`
      );
      // console.log(response.data);
      this.snippet = response.data;
    },
    async fetchTemplate() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}/snippet/template`
      );
      // console.log(response.data);
      this.template = response.data;
    },
    async fetchDocumentCount() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}/documents/count`
      );
      // console.log(response.data);
      this.documentCount = response.data;
    },
    async deleteRevision() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/document/templateRevisions/${this.$route.params.id}`
        );
        //console.log(response.data);
        this.$router.push({
          name: "snippet",
          params: { id: this.templateRevision.snippetid }
        });
      }
    },
    async togglePublish() {
      await nbmlaw.put(
        `/cors/admin/document/templateRevisions/${this.$route.params.id}/publish`,
        null
      );
      this.fetchTemplateRevision();
    },
    exportRevision() {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/document/templateRevisions/${this.templateRevision.id}/export`,
        "_blank"
      );
    },
    downloadRevision() {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/document/templateRevisions/${this.templateRevision.id}/pdf`,
        "_blank"
      );
    },
    update() {
      this.fetchTemplateRevision();
      this.fetchSnippet();
      this.fetchTemplate();
      this.fetchDocumentCount();
    }
  },
  created() {
    this.update();
  }
};
</script>
